import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import useIsMobile from 'common/hooks/useIsMobile'
import useFormHandlers from 'components/Form/AppForm/hooks/useFormHandlers'
import { PAGE_STEPER_STAGES } from 'components/Navbar/pageSteps'
import { AppLinks } from 'enviroment/AppLinks'
import { IAdditionalRetentionData } from 'service/FormSubmitionService/FormSubmitionModels'
import { FormSubmitionService } from 'service/FormSubmitionService/FormSubmitionService'
import { AppState } from 'store'
import { changeApplicationStep, changeWorkflow } from 'store/ApplicationSlice/ApplicationSlice'
import { UseRetentionPageLogicReturnProps } from '../RetentionPageProps'
import { WorkflowTypes } from 'common/workflow'
import settingsService from 'service/SettingsService/SettingsService'
import { ConsentType } from 'service/SettingsService/SettingsServiceModels'
import { appConsentsFetched, consentsFetched } from 'store/ConsentsSlice/ConsentsSlcie'
import { sleep } from 'common/helpers/helpers'
import applicationService from 'service/ApplicaionService/ApplicationService'
import { collectBikData } from 'common/helpers/collectBikData'

declare global {
   interface Window {
     ptadx: {
       ptinitiate: Function;
       ptvalidate: Function;
     }
   }
}


const useRetentionPageLogic = (): UseRetentionPageLogicReturnProps => {
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const isMobileDevice = useIsMobile()
   
   const appConsents = useSelector((state: AppState) => state.consentsState.appConsents)
   const applicationState = useSelector((state: AppState) => state.applicationState)

   const { checkIsRequiredConsentsMarked } = useFormHandlers()

   useEffect(() => {
      window.ptadx.ptinitiate(null) //Inicjalizacja skryptu BIK CFD dla procesu RETENCJI
      dispatch(changeApplicationStep(PAGE_STEPER_STAGES.SUBMIT_APPLICATION))
   }, [])


   /**
    * Funkcja wywoływana w przypadku kliknięcia w przycisk "KLIKNIJ TUTAJ" i przejścia do formularza.
    * Pobiera ona zgody dla procesu STANDARDOWEGO, ustawia ona WorkflowType na OTP_NORMAL, 
    * czeka co najmniej sekundę na stronie ładowania i przenosi użytkownika do formularza.
    * 
    * W razie błędu z pobieraniem zgód, przenosi użytkownika na stronę z error
   */
   const handleChangeCurrentWorkflow = async () => {
      collectBikData(); //Przed przejściem na kolejną stronę, pobieramy dane z BIK i zapisujemy je w sessionStorage.

      (async () => {
         navigate(AppLinks.waiting)

         try {
            const consents = await settingsService.getConsents(ConsentType.Standard)
            await applicationService.updateWorkflow(WorkflowTypes.OTP_NORMAL) // Zmieniamy obecny workflow po stronie Backendu

            dispatch(consentsFetched(consents))
            dispatch(appConsentsFetched(consents))
            dispatch(changeWorkflow(WorkflowTypes.OTP_NORMAL)) // Aktualizujemy Workflow po stronie Frontendu

            await sleep(1000) // Wymuszamy czekanie na stronie ładowania co najmniej sekundę. Ważne z punktu wizualnego w momencie gdy zgody aplikacji zbyt szybko się pobiorą
            navigate(AppLinks.basicInfoForm)
         }
         catch (e) {
            await sleep(1000) // Wymuszamy czekanie na stronie ładowania co najmniej sekundę.
            navigate(AppLinks.error)
         }
     })()
   }

   /**
    * Funkcja walidująca czy wszystkie zgody zostały poprawnie zaznaczone oraz składająca wniosek retencyjny
    * @returns 
    */
   const handleSubmitRetention = () => {
      const consentsValidationResult = checkIsRequiredConsentsMarked(appConsents)
      const scrollToErrorInput: Element = document.getElementsByClassName('app-consents-main-error')[0] //Pobieramy klasę dołączaną w przypadku gdy zgody zostaną błędnie
      
      if(scrollToErrorInput !== undefined ) {
         scrollToErrorInput.scrollIntoView({ behavior:"smooth", block: "center" })
      }

      if(consentsValidationResult) { // Sytuacja gdy jakaś zgoda wymagana jest niezaznaczona
         return
      }
      else { // Sytuacja gdy nie ma błędów walidacyjnych i można przejść dalej
         const submitionService = new FormSubmitionService()

         //Zbieranie danych ze skryptu BIK dla retencji
         const inputHDIM = document.getElementById('ptsuser_prefs2') as HTMLInputElement
         const JSC = window.ptadx.ptvalidate('ptsuser_prefs') ?? "" //Dodano na potrzeby BIK CFD
         const HDIM = inputHDIM?.value ?? "" //Dodano na potrzeby BIK CFD

         const additionalRetentionData: IAdditionalRetentionData = {
            payingBillCompany: applicationState.billingCompany,
            jsc: JSC,
            hdim: HDIM
         }

         const retentionSubmitionModel = submitionService.mapFieldsToRetentionSubmitionModel(appConsents, additionalRetentionData)
         submitionService.submitBasicRetention(retentionSubmitionModel)

         navigate(AppLinks.bmWaiting)
      }
   }
   
   return {
      isMobileDevice,
      hashedPhoneNumber: applicationState.hashedPhoneNumber,
      handleSubmitRetention,
      handleChangeCurrentWorkflow
   }
}

export default useRetentionPageLogic